import { Logo } from "@/components/Logo";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";

const sections = [
  {
    title: "1. Pengenalan",
    body: "EY 58 Group (\"kami\") menghormati privasi anda. Polisi Privasi ini menerangkan bagaimana kami mengumpul, menggunakan, menyimpan dan melindungi maklumat peribadi anda apabila anda melayari laman web ini atau menghubungi kami melalui WhatsApp. Dengan menggunakan laman web ini, anda bersetuju dengan amalan yang dinyatakan dalam polisi ini.",
  },
  {
    title: "2. Maklumat Yang Kami Kumpul",
    body: "Kami mungkin mengumpul maklumat berikut: (a) maklumat yang anda berikan secara sukarela melalui WhatsApp seperti nama, nombor telefon dan maklumat kewangan asas untuk tujuan semakan kelayakan; (b) maklumat teknikal yang dikumpul secara automatik seperti alamat IP, jenis peranti, jenis pelayar dan halaman yang dilawati, melalui alat analitik seperti Meta Pixel dan Google Analytics (jika diaktifkan).",
  },
  {
    title: "3. Bagaimana Kami Menggunakan Maklumat",
    body: "Maklumat yang dikumpul digunakan untuk: (a) memproses semakan awal kelayakan pembiayaan anda; (b) menghubungi anda berkaitan pertanyaan anda; (c) menambah baik kandungan dan prestasi laman web kami; dan (d) tujuan pengukuran dan pengiklanan (remarketing) di platform seperti Facebook dan Instagram. Kami tidak menjual maklumat peribadi anda kepada mana-mana pihak.",
  },
  {
    title: "4. Penzahiran Kepada Pihak Ketiga",
    body: "Kami hanya berkongsi maklumat anda dengan: (a) perunding dan rakan pembiaya yang berkaitan untuk tujuan semakan kelayakan, dengan kebenaran anda; (b) penyedia perkhidmatan teknikal (contohnya Meta Platforms untuk tujuan pengiklanan); dan (c) pihak berkuasa jika dikehendaki oleh undang-undang Malaysia.",
  },
  {
    title: "5. Keselamatan Data",
    body: "Kami mengambil langkah keselamatan yang munasabah untuk melindungi maklumat peribadi anda daripada akses, penggunaan atau penzahiran yang tidak dibenarkan. Walau bagaimanapun, tiada kaedah penghantaran melalui internet yang 100% selamat, dan anda dinasihatkan untuk tidak berkongsi maklumat sensitif seperti kata laluan perbankan melalui WhatsApp.",
  },
  {
    title: "6. Cookies & Pengiklanan",
    body: "Laman web ini mungkin menggunakan cookies dan teknologi pengesanan seperti Meta Pixel untuk memahami tingkah laku pelawat dan mengukur keberkesanan iklan kami. Anda boleh mengawal cookies melalui tetapan pelayar anda. Menyahaktifkan cookies tidak akan menjejaskan keupayaan anda untuk menghubungi kami melalui WhatsApp.",
  },
  {
    title: "7. Hak Anda",
    body: "Di bawah Akta Perlindungan Data Peribadi 2010 (PDPA) Malaysia, anda berhak untuk: (a) mengakses maklumat peribadi yang kami simpan tentang anda; (b) membetulkan maklumat yang tidak tepat; dan (c) memohon pemadaman maklumat anda. Untuk menggunakan hak ini, sila hubungi kami melalui WhatsApp.",
  },
  {
    title: "8. Perubahan Kepada Polisi Ini",
    body: "Kami mungkin mengemas kini Polisi Privasi ini dari semasa ke semasa. Sebarang perubahan akan dipaparkan di halaman ini dengan tarikh kuat kuasa yang baharu. Anda dinasihatkan untuk menyemak halaman ini secara berkala.",
  },
  {
    title: "9. Hubungi Kami",
    body: "Jika anda mempunyai sebarang pertanyaan mengenai Polisi Privasi ini atau cara kami mengendalikan data anda, sila hubungi kami melalui butang WhatsApp di laman web ini. Kami akan membalas pertanyaan anda secepat mungkin.",
  },
];

const PrivacyPolicy = () => (
  <div
    data-testid="privacy-policy-page"
    className="min-h-screen bg-white font-body"
  >
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-navy/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-[72px] flex items-center">
        <Logo />
      </div>
    </header>

    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <p className="text-sm text-gold-dark uppercase tracking-widest font-semibold">
        EY 58 Group
      </p>
      <h1
        data-testid="privacy-policy-heading"
        className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-navy"
      >
        Polisi Privasi
      </h1>
      <p className="mt-4 text-sm text-slate-500">
        Tarikh kuat kuasa: 1 Julai 2026
      </p>

      <div data-testid="privacy-policy-content" className="mt-12 space-y-10">
        {sections.map((section) => (
          <section key={section.title}>
            <h2 className="font-heading text-xl sm:text-2xl font-semibold text-navy">
              {section.title}
            </h2>
            <p className="mt-3 text-base text-slate-600 leading-relaxed">
              {section.body}
            </p>
          </section>
        ))}
      </div>
    </main>

    <Footer />
    <FloatingWhatsApp />
  </div>
);

export default PrivacyPolicy;
